import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {api} from 'api/setup';
import {useRouter} from 'next/router';
import {ICarouselsProducts, QueryKeyEnum} from 'types';

export const useDailyLunch = (query?: string, options?: UseQueryOptions<any>) => {
  const {locale} = useRouter();

  return useQuery<ICarouselsProducts>({
    queryKey: [QueryKeyEnum.DAILY_LUNCH, locale, query],
    queryFn: () => api.get('/product-carousels' + (query || '')),
    ...options,
  });
};

export const useDailyLunchHome = (query?: string, options?: UseQueryOptions<any>) => {
  const {locale} = useRouter();

  return useQuery<ICarouselsProducts[]>({
    queryKey: [QueryKeyEnum.DAILY_LUNCH, locale],
    queryFn: () => api.get('/product-carousels'),
    ...options,
  });
};
